import { QuickAdd } from "../Main/QuickAdd";
import { Facets } from "../Facets/facets";
import { CategoryProduct } from "./CategoryProduct";

export class Category {
    private readonly facets: Facets;
    private readonly filterTabHeader = document.getElementById("filter-tab-header");
    private readonly categoryTabHeader = document.getElementById("category-tab-header");
    private readonly sideCategoryTab = document.getElementById("side-category-tab");
    private readonly facetTab = document.getElementById("facetTab");

    public static Init(): Category {
        return new Category();
    }

    constructor() {
        this.setReadMoreCollapsers();
        this.wireUpCategoryFacetSwitching();
        if (this.facetTab) {
            this.facets = new Facets();
            new QuickAdd();
            new CategoryProduct();
        }
    }

    /**
     * The read more button is set to show by default on mobile when the page loads (it will not have the hidden class).
     * If the text is fully visible then this javascript will remove it.
     * Mobile is defined as when the hidden class has not been applied to a 'read-more-label' element.
     * 
     * On desktop the read more links are hidden by default (using the hidden class).
     * This function detects if the text is too long and if so removes the 'read more' hidden class.
     * Desktop is defined as when the hidden class has been applied to a 'read-more-label' element.
     */
    private setReadMoreCollapsers(): void {
        let descriptionElement = document.querySelector(".read-more-wrap");

        if (descriptionElement) {
            let isContentFullyVisible = descriptionElement.scrollHeight <= descriptionElement.clientHeight;
            let readMoreElements = document.querySelectorAll(".read-more-label");
            let readMoreIsHidden = false;

            // If any of the elements has the hidden class then we are on desktop.
            readMoreElements.forEach(readMoreElement => {
                if (readMoreElement.classList.contains("hidden")) {
                    readMoreIsHidden = true;
                }
            });

            if (readMoreIsHidden) {
                if (!isContentFullyVisible) {
                    // Show the read more button as the text is not fully visible and read more is currently hidden.
                    readMoreElements.forEach(readMoreElement => {
                        readMoreElement.classList.remove("hidden");
                    });
                }
            }
            else if (isContentFullyVisible) {
                // We are on mobile, so hide the read more button if the text is fully visible.
                readMoreElements.forEach(readMoreElement => {
                    readMoreElement.classList.add("hidden");
                });
            }
        }
    }

    private wireUpCategoryFacetSwitching(): void {
        if (this.filterTabHeader) {
            this.filterTabHeader.addEventListener("click", (e) => this.onFilterTabClicked(e));
        }
        if (this.categoryTabHeader) {
            this.categoryTabHeader.addEventListener("click", (e) => this.onCategoryTabClicked(e));
        }

        let filterMobile = document.querySelector(".filter-by-mb");
        if (filterMobile) {
            filterMobile.addEventListener("click", (e) => this.onMobileFilterClicked(e));
        }
        let closeFilterMobile = document.querySelector(".close-filter");
        if (closeFilterMobile) {
            closeFilterMobile.addEventListener("click", (e) => this.facets?.closeMobileFilter(e));
        }
    }

    private onMobileFilterClicked(e: Event): void {
        e.preventDefault();

        document.documentElement.classList.add("show-filter");

        let firstFacetDiv = document.querySelector<HTMLElement>("#facetTab>ul>li>div");

        if (!this.isVisible(firstFacetDiv)) {
            let filterToggleArrow = firstFacetDiv.parentElement.querySelector(".filterToggleArrow");

            filterToggleArrow.dispatchEvent(new Event("click", { bubbles: true, cancelable: true }));
        }
    }

    private isVisible(el: HTMLElement): boolean {
        let style = window.getComputedStyle(el);
        return style.display !== 'none';
    }

    private onFilterTabClicked(e: MouseEvent): void {
        e.preventDefault();

        this.filterTabHeader.classList.add("active");
        this.categoryTabHeader.classList.remove("active");
        this.sideCategoryTab.classList.add("hidden");
        this.facetTab.classList.remove("hidden");
    }

    private onCategoryTabClicked(e: MouseEvent): void {
        e.preventDefault();

        this.filterTabHeader.classList.remove("active");
        this.categoryTabHeader.classList.add("active");
        this.sideCategoryTab.classList.remove("hidden");
        this.facetTab.classList.add("hidden");
    }
}

if (document.body.dataset.pageInit == "category") {
    Category.Init();
}